import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import "../reading.css";
import { randGroup, randDelay, randNotif } from "../utils";
import Demo from "./MSN Popups/newDemo";
import Demo2 from "./MSN Popups/newDemo2";
import Demo3 from "./MSN Popups/newDemo3";
import Demo4 from "./MSN Popups/newDemo4";

function Reading() {
  const [able1, setAble1] = React.useState(true);

  console.log("Saved user group: ", randGroup);

  var trigger;
  if (randNotif === 1) {
    trigger = <Demo />;
  } else if (randNotif === 2) {
    trigger = <Demo2 />;
  } else if (randNotif === 3) {
    trigger = <Demo3 />;
  } else if (randNotif === 4) {
    trigger = <Demo4 />
  }

  function quiz() {
    var start_time = new Date();
    localStorage.setItem("starting_time", start_time);
    console.log("quiz starting time: " + start_time);
    localStorage.setItem("reading_end_time", new Date());
  };

  var label_item = localStorage.getItem("label_item");
  console.log("Setting choice is: " + label_item);

  // let user continue after 5 minutes
  useEffect(() => {
    const timer = setTimeout(() => {
      setAble1(false);
    }, 300000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="body">
      { (randDelay === 1) ? trigger : <></> }
      <br></br>
      <p><b>Please interact with this task for 5 minutes. After 5 minutes, the continue button will become active and you can proceed to the next portion of the platform.</b></p>
      <br></br>
      <div id="article_div">
        <div id="hide_reading_portion">
          <h1
            style={{
              textDecoration: "underline",
              fontWeight: "bold",
              fontSize: 25,
            }}
          >
            The economic potential of generative AI: The next productivity frontier
          </h1>
          <p>
            <br></br>
            Generative AI applications such as ChatGPT, GitHub Copilot, Stable Diffusion, and others have captured the imagination of people around the world
             in a way AlphaGo did not, thanks to their broad utility—almost anyone can use them to communicate and create—and preternatural ability to have a 
             conversation with a user. The latest generative AI applications can perform a range of routine tasks, such as the reorganization and classification 
             of data. But it is their ability to write text, compose music, and create digital art that has garnered headlines and persuaded consumers and households 
             to experiment on their own. As a result, a broader set of stakeholders are grappling with generative AI’s impact on business and society but without much 
             context to help them make sense of it. 
          </p>
          <br></br>
          <p>
            To grasp what lies ahead requires an understanding of the breakthroughs that have enabled the rise of generative AI, which were decades in the making. 
            For the purposes of this report, we define generative AI as applications typically built using foundation models. These models contain expansive artificial 
            neural networks inspired by the billions of neurons connected in the human brain. Foundation models are part of what is called deep learning, a term that 
            alludes to the many deep layers within neural networks. Deep learning has powered many of the recent advances in AI, but the foundation models powering generative 
            AI applications are a step-change evolution within deep learning. Unlike previous deep learning models, they can process extremely large and varied sets of unstructured 
            data and perform more than one task. 
          </p>
          <br></br>
          <p>
            <b>Where business value lies.</b> Generative AI is a step change in the evolution of artificial intelligence. As companies rush to adapt and implement it, understanding the technology’s potential to deliver 
            value to the economy and society at large will help shape critical decisions. We have used two complementary lenses to determine where generative AI, with its current capabilities, 
            could deliver the biggest value and how big that value could be. 
          </p>
          <br></br>
          <p>
            The first lens scans use cases for generative AI that organizations could adopt. We define a “use case” as a targeted application of generative AI to a specific business challenge, 
            resulting in one or more measurable outcomes. For example, a use case in marketing is the application of generative AI to generate creative content such as personalized emails, the 
            measurable outcomes of which potentially include reductions in the cost of generating such content and increases in revenue from the enhanced effectiveness of higher-quality content at scale. 
            We identified 63 generative AI use cases spanning 16 business functions that could deliver total value in the range of $2.6 trillion to $4.4 trillion in economic benefits annually when applied 
            across industries. 
          </p>
          <br></br>
          <p>
            Our second lens complements the first by analyzing generative AI’s potential impact on the work activities required in some 850 occupations. We modeled scenarios to estimate when generative 
            AI could perform each of more than 2,100 “detailed work activities”—such as “communicating with others about operational plans or activities”—that make up those occupations across the world 
            economy. This enables us to estimate how the current capabilities of generative AI could affect labor productivity across all work currently done by the global workforce. 
          </p>
          <br></br>
          <h3 style={{ textDecoration: "underline" }}>Source</h3>
          <p>
            The economic potential of generative AI: The next productivity frontier By McKinsey and Company. 
            https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights/the-economic-potential-of-generative-ai-the-next-productivity-frontier 
          </p>
          <br></br>
          {/* After 5 minutes, enable this button for the after task group*/}
          <Button 
            style={{ textTransform: "none" }} 
            variant="contained" 
            size="small" 
            color="primary" 
            disabled={able1}
            onClick={quiz}>
            <Link 
              to={"/quiz"} 
              style={{ color: "white" }}>
              Continue
            </Link>
          </Button>
          <br></br>
          <br></br>
        </div>
      </div>
    </div>
  );
}

export default Reading;
